import { useState } from 'react';
import { X, Check } from 'lucide-react';
import { pmT } from '../../lib/i18nPm';
import { BRANCHES, agentOf } from '../../lib/pm';
import { BrChip } from './BrChip';
import { SubPick } from './SubChip';
import { getSub } from '../../lib/profiles';

// new project: one branch (current one preset) or cross-branch with chosen branches only
export function PmNew({ t, app, onClose, onDone }) {
  const T = pmT(), cur = BRANCHES.includes(app.mode) ? app.mode : 'pipe';
  const [kind, setKind] = useState('single'), [name, setName] = useState(''), [cust, setCust] = useState(''), [br, setBr] = useState([cur]), [subs, setSubs] = useState(cur === 'detect' ? [getSub()] : []);
  const tog = (b) => setBr(kind === 'single' ? [b] : br.includes(b) ? br.filter((x) => x !== b) : [...br, b]);
  const go = async () => { const p = await app.create({ name, customer: cust, kind, branches: br, subs: br.includes('detect') ? subs : [] }); if (p?.id) onDone(p.id); };
  return (
    <div className="pm-modal" data-testid="pm-new" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="pm-modal-box">
        <div className="pm-head"><h2>{T.newProj}</h2><button className="pm-icon" onClick={onClose} data-testid="pm-new-close"><X size={18} /></button></div>
        <input className="pm-input" placeholder={T.name} value={name} onChange={(e) => setName(e.target.value)} data-testid="pm-new-name" autoFocus />
        <input className="pm-input" placeholder={T.customer} value={cust} onChange={(e) => setCust(e.target.value)} data-testid="pm-new-customer" />
        <div className="pm-kinds">
          {[['single', T.kSingle, T.kSingleTxt], ['cross', T.kCross, T.kCrossTxt]].map(([k, l, d]) => (
            <button key={k} className={`pm-kind ${kind === k ? 'active' : ''}`} data-testid={`pm-new-kind-${k}`} onClick={() => { setKind(k); if (k === 'single') setBr([br[0] || cur]); }}>{kind === k && <Check size={14} />}<b>{l}</b><small>{d}</small></button>
          ))}
        </div>
        <b>{T.pickBr}</b>
        <div className="pm-branch-chips">{BRANCHES.map((b) => <BrChip key={b} b={b} t={t} active={br.includes(b)} onClick={() => tog(b)} testid={`pm-new-br-${b}`} />)}</div>
        <small className="pm-muted">{br.map(agentOf).join(' · ')}</small>
        {br.includes('detect') && <><b>{T.subT}</b><SubPick t={t} value={subs} onChange={setSubs} prefix="pm-new" /></>}
        <button className="pm-btn pm-primary" disabled={!br.length || !name.trim() || (br.includes('detect') && !subs.length)} data-testid="pm-new-create" onClick={go}>{T.create}</button>
      </div>
    </div>
  );
}
